import { render } from "./DevPdfDownloader.vue?vue&type=template&id=6ff16cbc"
import script from "./DevPdfDownloader.vue?vue&type=script&lang=js"
export * from "./DevPdfDownloader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__